"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BUTTON = void 0;
const colors_1 = require("../styles/colors");
const constants_1 = require("../utils/constants");
exports.BUTTON = {
    variants: [
        {
            props: { variant: 'text' },
            style: {
                color: colors_1.$primaryWhite,
            },
        },
        {
            props: { variant: 'no-background-primary' },
            style: {
                color: colors_1.$primaryBrand,
                background: 'transparent',
                '&:disabled': {
                    color: colors_1.$grey10,
                    background: 'transparent',
                },
                '&:hover': {
                    background: 'transparent',
                },
                '&:focus': {
                    background: 'transparent',
                    border: 'none',
                },
            },
        },
        {
            props: { variant: 'no-background-secondary' },
            style: {
                color: colors_1.$primaryNavy,
                background: 'transparent',
                '&:disabled': {
                    color: colors_1.$grey10,
                    background: 'transparent',
                },
                '&:hover': {
                    background: 'transparent',
                },
                '&:focus': {
                    background: 'transparent',
                    border: 'none',
                },
            },
        },
        {
            props: { variant: 'cta' },
            style: {
                color: colors_1.$primaryWhite,
                background: `transparent linear-gradient(113deg, ${colors_1.$primaryBrand} 0%, ${colors_1.$primaryNavy} 100%) 0% 0% no-repeat padding-box`,
                '&:hover': {
                    background: `transparent linear-gradient(113deg, ${colors_1.$secondaryBlue} 0%, ${colors_1.$focusedInput} 100%) 0% 0% no-repeat padding-box`,
                },
                '&:focus': {
                    background: `transparent linear-gradient(113deg, ${colors_1.$secondaryBlue} 0%, ${colors_1.$focusedInput} 100%) 0% 0% no-repeat padding-box`,
                    border: `1px solid ${colors_1.$primaryNavy}`,
                    borderRadius: '4px',
                    opacity: '1',
                },
                '&:disabled': {
                    background: colors_1.$grey10,
                    color: colors_1.$primaryWhite,
                },
            },
        },
        {
            props: { variant: 'outlined' },
            style: {
                color: colors_1.$primaryBrand,
                '&:hover': {
                    color: colors_1.$primaryWhite,
                    background: colors_1.$secondaryBlue,
                },
                '&:focus': {
                    color: colors_1.$primaryWhite,
                    background: colors_1.$secondaryBlue,
                    border: `${colors_1.$primaryNavy} solid 1px`,
                },
            },
        },
        {
            props: { variant: 'secondary-dark' },
            style: {
                color: colors_1.$primaryNavy,
                background: `${colors_1.$primaryWhite} 0% 0% no-repeat padding-box`,
                boxShadow: `0px 2px 4px ${colors_1.$greyBoxShadow}`,
                '&:hover': {
                    color: colors_1.$primaryWhite,
                    background: `${colors_1.$primaryNavy} 0% 0% no-repeat padding-box`,
                    boxShadow: `0px 2px 4px ${colors_1.$greyBoxShadow}`,
                    borderRadius: '4px',
                },
                '&:focus': {
                    color: colors_1.$primaryNavy,
                    boxShadow: `0px 2px 4px ${colors_1.$greyBoxShadow}`,
                    border: `1px solid ${colors_1.$primaryNavy}`,
                    borderRadius: '4px',
                    background: `${colors_1.$primaryWhite} 0% 0% no-repeat padding-box`,
                },
                '&:disabled': {
                    background: `${colors_1.$grey10} 0% 0% no-repeat padding-box`,
                    color: colors_1.$primaryWhite,
                    boxShadow: 'none',
                },
            },
        },
        {
            props: { variant: 'remove-red' },
            style: {
                backgroundColor: colors_1.$darkRed,
                width: '32px',
                minWidth: '32px',
                height: '32px',
                paddingRight: '0',
                boxShadow: `0px 2px 4px ${colors_1.$greyBoxShadow}`,
                borderRadius: '4px',
                color: colors_1.$primaryWhite,
                '& .MuiButton-startIcon': {
                    marginRight: '12px',
                },
                '&:hover': {
                    color: colors_1.$darkRed,
                    backgroundColor: colors_1.$primaryWhite,
                    boxShadow: `0px 2px 4px ${colors_1.$greyBoxShadow}`,
                    border: `1px solid ${colors_1.$darkRed}`,
                },
                '&:focus': {
                    border: `1px solid ${colors_1.$primaryBlack}`,
                },
                '&:disabled': {
                    background: colors_1.$grey10,
                    color: colors_1.$primaryWhite,
                    boxShadow: 'none',
                },
                '&.MuiButton-sizeSmall': {
                    width: '32px',
                    minWidth: '32px',
                    height: '32px',
                    '& svg': {
                        fontSize: 'large',
                    },
                },
                '&.MuiButton-sizeMedium, &.MuiButton-sizeLarge': {
                    width: '40px',
                    minWidth: '40px',
                    height: '40px',
                },
            },
        },
        {
            props: { variant: 'icon-primary' },
            style: {
                background: `${colors_1.$primaryWhite} 0% 0% no-repeat padding-box`,
                borderRadius: '4px',
                opacity: '1',
                color: colors_1.$primaryBrand,
                boxShadow: `0px 2px 4px ${colors_1.$greyBoxShadow}`,
                '&.MuiButton-sizeSmall': {
                    width: '32px',
                    minWidth: '32px',
                    height: '32px',
                },
                '&.MuiButton-sizeMedium, &.MuiButton-sizeLarge': {
                    width: '40px',
                    minWidth: '40px',
                    height: '40px',
                },
                '&:disabled': {
                    background: `${colors_1.$grey10} 0% 0% no-repeat padding-box`,
                    color: colors_1.$primaryWhite,
                    boxShadow: 'none',
                },
                '&:hover': {
                    background: `${colors_1.$primaryBrand} 0% 0% no-repeat padding-box`,
                    color: colors_1.$primaryWhite,
                },
                '&:focus': {
                    background: `${colors_1.$primaryWhite} 0% 0% no-repeat padding-box`,
                    border: `1px solid ${colors_1.$primaryNavy}`,
                },
            },
        },
        {
            props: { variant: 'icon-secondary-dark-blue' },
            style: {
                background: `${colors_1.$primaryWhite} 0% 0% no-repeat padding-box`,
                boxShadow: `0px 2px 4px ${colors_1.$greyBoxShadow}`,
                borderRadius: '4px',
                opacity: '1',
                '&.MuiButton-sizeSmall': {
                    width: '32px',
                    minWidth: '32px',
                    height: '32px',
                },
                '&.MuiButton-sizeMedium, &.MuiButton-sizeLarge': {
                    width: '40px',
                    minWidth: '40px',
                    height: '40px',
                },
                '&:disabled': {
                    background: `${colors_1.$grey10} 0% 0% no-repeat padding-box`,
                    color: colors_1.$primaryWhite,
                    boxShadow: 'none',
                },
                '&:hover': {
                    background: `${colors_1.$primaryNavy} 0% 0% no-repeat padding-box`,
                    color: colors_1.$primaryWhite,
                },
                '&:focus': {
                    background: `${colors_1.$primaryWhite} 0% 0% no-repeat padding-box`,
                    border: `1px solid ${colors_1.$primaryNavy}`,
                },
            },
        },
        {
            props: { variant: 'favorite' },
            style: {
                color: colors_1.$grey10,
            },
        },
    ],
    styleOverrides: {
        root: {
            '&.MuiButton-sizeSmall': {
                height: '32px',
                minWidth: '89px',
                padding: '0 16px',
            },
            '&.MuiButton-sizeMedium, &.MuiButton-sizeLarge': {
                height: '40px',
                minWidth: '96px',
                padding: '0 16px',
            },
        },
        textPrimary: Object.assign({ background: colors_1.$primaryBrand }, constants_1.DS_BUTTON_STATE),
    },
};
